import { ArrowUpRight } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function EtsyButton({ href, className = "", testId = "buy-etsy-button" }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`group inline-flex items-center justify-center gap-2 rounded-full bg-blush px-8 py-4 font-bold text-white transition-all duration-300 hover:bg-blush-deep hover:shadow-xl hover:shadow-blush-soft ${className}`}
    >
      Buy on Etsy
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </a>
  );
}

export function AmazonButton({ href, className = "", testId = "buy-amazon-button" }) {
  if (!href) {
    return (
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="inline-flex cursor-not-allowed">
              <button
                type="button"
                disabled
                data-testid={testId}
                className={`inline-flex items-center justify-center gap-2 rounded-full border border-ink/15 bg-white px-8 py-4 font-bold text-ink ${className}`}
              >
                Buy on Amazon
              </button>
            </span>
          </TooltipTrigger>
          <TooltipContent data-testid="buy-amazon-tooltip" className="bg-ink text-cream">
            Amazon listing link coming soon
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`group inline-flex items-center justify-center gap-2 rounded-full border border-ink/15 bg-white px-8 py-4 font-bold text-ink transition-all duration-300 hover:border-ink hover:shadow-lg ${className}`}
    >
      Buy on Amazon
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </a>
  );
}
